'use es6';

import { connect } from 'react-redux';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd-compat';
import { ELEMENT, SECTION, ELEMENT_PLACEHOLDER, LAYOUT, SAVE_SECTION, RESIZE_HANDLE } from 'LayoutBuilderUI/lib/DragDropConstants';
import { startAppDrag as startAppDragAction, endedAppDrag as endedAppDragAction } from 'LayoutBuilderUI/actions/layoutActions';
import { NativeTypes } from 'react-dnd-ipeui-backend';
import { jsx as _jsx } from "react/jsx-runtime";
const dropTargetSpec = {
  canDrop() {
    // Never allow a drop at this top level
    return false;
  }
};
const dropTargetCollect = monitor => {
  return {
    draggedItemType: monitor.getItemType(),
    isDraggingWithinApp: monitor.isOver()
  };
};

// Custom hook to prevent useEffect firing on component mount
// (from https://stackoverflow.com/questions/53179075/with-useeffect-how-can-i-skip-applying-an-effect-upon-the-initial-render)
const useEffectSkippingMount = (func, dependencies) => {
  const didMountRef = useRef(false);
  useEffect(() => {
    if (didMountRef.current) {
      func();
    } else {
      didMountRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
const DraggingAwarenessDiv = ({
  id,
  onClick,
  children,
  startAppDrag,
  endedAppDrag,
  isDraggingWithinApp,
  draggedItemType,
  connectDropTarget
}) => {
  useEffectSkippingMount(() => {
    if (isDraggingWithinApp && draggedItemType) {
      startAppDrag(draggedItemType);
    } else if (!isDraggingWithinApp && !draggedItemType) {
      endedAppDrag();
    }
  }, [isDraggingWithinApp, draggedItemType, startAppDrag, endedAppDrag]);
  return connectDropTarget( /*#__PURE__*/_jsx("div", {
    id: id,
    onClick: onClick,
    children: children
  }));
};
DraggingAwarenessDiv.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  startAppDrag: PropTypes.func.isRequired,
  endedAppDrag: PropTypes.func.isRequired,
  isDraggingWithinApp: PropTypes.PropTypes.bool.isRequired,
  draggedItemType: PropTypes.string,
  connectDropTarget: PropTypes.func.isRequired
};
export default connect(undefined, {
  startAppDrag: startAppDragAction,
  endedAppDrag: endedAppDragAction
})(DropTarget([...Object.values([ELEMENT, ELEMENT_PLACEHOLDER, LAYOUT, SECTION, SAVE_SECTION, RESIZE_HANDLE]), NativeTypes.FILE], dropTargetSpec, dropTargetCollect)(DraggingAwarenessDiv));